import {ApiSlice} from "@/store/ApiSlice";
import RESTAPIConfig from "@/config/RESTAPIConfig";
import {NewBaseResponseInterface} from "@/common/Http/Interfaces/NewBaseResponseInterface";

const restApiConfig = new RESTAPIConfig();

export const DeleteFileMeaningsApiSlice = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        deleteFileMeaning: builder.mutation<NewBaseResponseInterface<unknown, unknown>, string>({
            query: (id: string) => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.fileMeaning(),
                method: 'DELETE',
                params: {
                    id,
                }
            }),
            invalidatesTags: (result, error) => {
                if (!error) {
                    return ["FileMeanings"];
                }
                return [];
            }
        })
    })
});

export const {useDeleteFileMeaningMutation} = DeleteFileMeaningsApiSlice;
